export function formatNumber(
  value: number | string,
  maximumFractionDigits = 2
): string {
  const num = typeof value == "string" ? parseFloat(value) : value
  return isNaN(num)
    ? value.toString()
    : Intl.NumberFormat("he-IL", {
        maximumFractionDigits,
      }).format(num)
}

export const formatPhone = (number: string) =>
  number.replace(/^(\d{2,3})(\d{7})$/, "$1-$2")

export function formatCurrency(value: number, maximumFractionDigits = 0) {
  return Intl.NumberFormat("he-IL", {
    maximumFractionDigits,
  }).format(value)
}

export const formatCurrencyWithSybmol = (value) => {
  const currencySymbol = "₪"
  if (value?.length === 0 || value === "₪") return ""
  if (value?.toString().startsWith(currencySymbol)) {
    return value
  }

  return `${currencySymbol}${value}`
}

const startsWithHebrewRegex = /^[\u0590-\u05fe]/
export function getDirection(unit: string) {
  return startsWithHebrewRegex.test(unit) ? "rtl" : "ltr"
}

export const trimPersonalId = (number: string) => number?.replace(/^0+/, "")
